var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TaskAuthInfo_1;
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
export var TaskAuthInfoType;
(function (TaskAuthInfoType) {
    TaskAuthInfoType["Import"] = "import";
    TaskAuthInfoType["Export"] = "export";
})(TaskAuthInfoType || (TaskAuthInfoType = {}));
const TaskAuthInfoSchema = {
    $id: 'urn:wisepipe-common-auth:TaskAuthInfo',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        userID: { type: 'string', format: 'uuid' },
        // taskID format will be `taskType-taskID`, e.g. `import-importID`
        taskID: { type: 'string' },
        taskAuthToken: { type: 'string' },
        expiration: { type: 'integer' },
        // endpoint is not required and not stored in the ddb, it's only used for the singer configs later
        // endpoint is a combination for domainName and path
        endpoint: { type: 'string' }
    },
    required: ['orgID', 'userID', 'taskID', 'taskAuthToken', 'expiration']
};
let TaskAuthInfo = TaskAuthInfo_1 = class TaskAuthInfo {
    constructor(orgID, userID, taskID, taskAuthToken, expiration, endpoint) {
        this.orgID = orgID;
        this.userID = userID;
        this.taskID = taskID;
        this.taskAuthToken = taskAuthToken;
        this.expiration = expiration;
        this.endpoint = endpoint;
        JSON.validate(this, TaskAuthInfo_1);
    }
    async encrypt(encryptFn) {
        const enTaskAuthToken = await encryptFn(this.taskAuthToken);
        return new TaskAuthInfo_1(this.orgID, this.userID, this.taskID, enTaskAuthToken, this.expiration, this.endpoint);
    }
    async decrypt(decryptFn) {
        const deTaskAuthToken = await decryptFn(this.taskAuthToken);
        return new TaskAuthInfo_1(this.orgID, this.userID, this.taskID, deTaskAuthToken, this.expiration, this.endpoint);
    }
};
TaskAuthInfo = TaskAuthInfo_1 = __decorate([
    JsonSchema(TaskAuthInfoSchema)
], TaskAuthInfo);
export { TaskAuthInfo };
//# sourceMappingURL=taskAuthInfo.js.map